import * as i0 from '@angular/core';
import { PLATFORM_ID, Injectable, Inject, NgModule } from '@angular/core';
import { map } from 'rxjs/operators';
import * as i2 from '@adeo/ngx-kozikaza-api';
import { BaseService, KOZIKAZA_API_OPTIONS, createSubResourceObservables, createSubResourceObservable, ProfessionalService, UserService } from '@adeo/ngx-kozikaza-api';
import * as i1 from '@angular/common/http';

var ProfessionalServiceSubResource;
(function (ProfessionalServiceSubResource) {
    ProfessionalServiceSubResource.Professional = 'professional';
    ProfessionalServiceSubResource.Author = 'author';
    ProfessionalServiceSubResource.Medias = 'medias';
    ProfessionalServiceSubResource.MediaObjects = 'mediaObjects';
    ProfessionalServiceSubResource.MediaFile = 'mediaFile';
    ProfessionalServiceSubResource.Types = 'types';
})(ProfessionalServiceSubResource || (ProfessionalServiceSubResource = {}));

var ProfessionalServicePriceType;
(function (ProfessionalServicePriceType) {
    ProfessionalServicePriceType["PriceText"] = "priceText";
    ProfessionalServicePriceType["Quotation"] = "quotation";
    ProfessionalServicePriceType["PriceNumber"] = "priceNumber";
})(ProfessionalServicePriceType || (ProfessionalServicePriceType = {}));

class ProfessionalServiceTypeService extends BaseService {
    platformId;
    injector;
    static endpoint = '/professionals/service_types';
    static endpointPrefix = '/professionals';
    static endpointStylesSuffix = '/service_types';
    getWebServiceName() {
        return 'ProfessionalServiceTypeWebService';
    }
    constructor(options, httpClient, platformId, cache, logger, injector) {
        super(options, httpClient, platformId, cache, logger);
        this.platformId = platformId;
        this.injector = injector;
    }
    postProfessionalServiceTypes(professionalStyle, options) {
        return this.post(ProfessionalServiceTypeService.endpoint, professionalStyle, options);
    }
    getProfessionalServiceTypes(subResources, options) {
        return this.getResources(ProfessionalServiceTypeService.endpoint, subResources, options);
    }
    /*    getProfessionalServiceTypesNavigator(
            subResources?: ProfessionalServiceTypeSubResources,
            options?: WebServiceOptions,
        ): Observable<HydraCollectionNavigator<ProfessionalServiceType>> {
            return this.getProfessionalServiceTypes(subResources, options)
                .pipe(
                    map(collection => new HydraCollectionNavigator(this, collection, subResources, options)),
                )
                ;
        }*/
    getProfessionalServiceType(professionalServiceType, subResources, options) {
        return this.getResource(ProfessionalServiceTypeService.endpointPrefix +
            (typeof professionalServiceType === 'string' ? professionalServiceType : professionalServiceType['@id']), subResources, options);
    }
    getProfessionalServiceTypeByProfessional(professional, subResources, options) {
        return this.getResources(ProfessionalServiceTypeService.endpointPrefix +
            `${typeof professional === 'string'
                ? professional : professional['@id']}${ProfessionalServiceTypeService.endpointStylesSuffix}`, subResources, options);
    }
    /*    getProfessionalServiceTypeByProfessionalNavigator(
            professional: Partial<Professional> | string,
            subResources?: ProfessionalServiceTypeSubResources,
            options?: WebServiceOptions,
        ): Observable<HydraCollectionNavigator<ProfessionalServiceType>> {
            return this.getProfessionalServiceTypeByProfessional(professional, subResources, options)
                .pipe(
                    map(collection => new HydraCollectionNavigator(this, collection, subResources, options)),
                );
        }*/
    /*    putProfessionalServiceType(
            professionalServiceType: Partial<ProfessionalServiceType>,
            options?: WebServiceOptions,
        ): Observable<ProfessionalServiceType> {
            return this.updateResource<ProfessionalServiceType>(
                ProfessionalServiceTypeService.endpointPrefix +
                (typeof professionalServiceType === 'string'
                    ? `${ ProfessionalServiceTypeService.endpointPrefix }` + professionalServiceType :
                    professionalServiceType['@id']),
                professionalServiceType,
                options,
            );
        }*/
    /*    deleteProfessionalServiceType(
            professionalServiceType: string | Partial<ProfessionalServiceType>,
            options?: WebServiceOptions,
        ): Observable<undefined> {
            return this.delete<undefined>(
                ProfessionalServiceTypeService.endpointPrefix +
                (typeof professionalServiceType === 'string'
                    ? `${ ProfessionalServiceTypeService.endpointPrefix }` + professionalServiceType :
                    professionalServiceType['@id']),
                options,
            );
        }*/
    getSubResourceObservable(professionalServiceType, subResourceRequest, options) {
        switch (subResourceRequest[0]) {
            default:
                return undefined;
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: ProfessionalServiceTypeService, deps: [{ token: KOZIKAZA_API_OPTIONS }, { token: i1.HttpClient }, { token: PLATFORM_ID }, { token: i2.CacheService }, { token: i2.Logger }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: ProfessionalServiceTypeService });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: ProfessionalServiceTypeService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [KOZIKAZA_API_OPTIONS]
                }] }, { type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }, { type: i2.CacheService }, { type: i2.Logger }, { type: i0.Injector }]; } });

class ProfessionalServiceService extends BaseService {
    platformId;
    injector;
    static endpoint = '/professionals/services';
    static endpointPrefix = '/professionals';
    static endpointServiceSuffix = '/services';
    getWebServiceName() {
        return 'ProfessionalWebServiceService';
    }
    constructor(options, httpClient, platformId, cache, logger, injector) {
        super(options, httpClient, platformId, cache, logger);
        this.platformId = platformId;
        this.injector = injector;
    }
    postProfessionalServices(professionalService, options) {
        return this.post(ProfessionalServiceService.endpoint, professionalService, options);
    }
    getProfessionalServices(subResources, options) {
        return this.getResources(ProfessionalServiceService.endpoint, subResources, options);
    }
    /*    getProfessionalServicesNavigator(
            subResources?: ProfessionalServiceSubResources,
            options?: WebServiceOptions,
        ): Observable<HydraCollectionNavigator<ProfessionalServiceRessource>> {
            return this.getProfessionalServices(subResources, options)
                .pipe(
                    map(collection => new HydraCollectionNavigator(this, collection, subResources, options)),
                )
                ;
        }*/
    getProfessionalService(professionalService, subResources, options) {
        return this.getResource(ProfessionalServiceService.endpointPrefix +
            (typeof professionalService === 'string' ? professionalService : professionalService['@id']), subResources, options);
    }
    getProfessionalServicesByProfessional(professional, subResources, options) {
        return this.getResources(`${ProfessionalServiceService.endpointPrefix}` +
            // eslint-disable-next-line max-len
            `${typeof professional === 'string' ? professional : professional['@id']}${ProfessionalServiceService.endpointServiceSuffix}`, subResources, options);
    }
    /*    getProfessionalServicesByProfessionalNavigator(
            professional: Partial<Professional> | string,
            subResources?: ProfessionalServiceSubResources,
            options?: WebServiceOptions,
        ): Observable<HydraCollectionNavigator<ProfessionalServiceRessource>> {
            return this.getProfessionalServicesByProfessional(professional, subResources, options)
                .pipe(
                    map(collection => new HydraCollectionNavigator(this, collection, subResources, options)),
                );
        }*/
    putProfessionalService(professionalService, options) {
        return this.updateResource(ProfessionalServiceService.endpointPrefix +
            (typeof professionalService === 'string' ? professionalService : professionalService['@id']), professionalService, options);
    }
    deleteProfessionalService(professionalService, options) {
        return this.delete(ProfessionalServiceService.endpointPrefix +
            (typeof professionalService === 'string' ? professionalService : professionalService['@id']), options);
    }
    getSubResourceObservable(professionalService, subResourceRequest, options) {
        switch (subResourceRequest[0]) {
            case ProfessionalServiceSubResource.Author:
                if (professionalService.author) {
                    return createSubResourceObservable(this.injector.get(UserService).getUser(professionalService.author, subResourceRequest[1], options), options)
                        .pipe(map(author => {
                        professionalService.author = author;
                        return professionalService;
                    }));
                }
                return undefined;
            case ProfessionalServiceSubResource.Professional:
                if (professionalService.professional) {
                    return createSubResourceObservable(this.injector.get(ProfessionalService).getProfessional(professionalService.professional, subResourceRequest[1], options), options)
                        .pipe(map(professional => {
                        professionalService.professional = professional;
                        return professionalService;
                    }));
                }
                return undefined;
            case ProfessionalServiceSubResource.Types:
                if (professionalService.types && professionalService.types.length > 0) {
                    const typesObservable = [];
                    professionalService.types.map(type => {
                        typesObservable.push(this.injector.get(ProfessionalServiceTypeService).getProfessionalServiceType(type, subResourceRequest[1], options));
                    });
                    return createSubResourceObservables(typesObservable, options, professionalService.types)
                        .pipe(map(types => {
                        professionalService.types = types;
                        return professionalService;
                    }));
                }
                return undefined;
            default:
                return undefined;
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: ProfessionalServiceService, deps: [{ token: KOZIKAZA_API_OPTIONS }, { token: i1.HttpClient }, { token: PLATFORM_ID }, { token: i2.CacheService }, { token: i2.Logger }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: ProfessionalServiceService });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: ProfessionalServiceService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [KOZIKAZA_API_OPTIONS]
                }] }, { type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }, { type: i2.CacheService }, { type: i2.Logger }, { type: i0.Injector }]; } });

const WEB_SERVICES = [
    ProfessionalServiceService,
    ProfessionalServiceTypeService,
];
class ProServiceApiModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: ProServiceApiModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.8", ngImport: i0, type: ProServiceApiModule });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: ProServiceApiModule, providers: [
            ...WEB_SERVICES,
        ] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: ProServiceApiModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [],
                    providers: [
                        ...WEB_SERVICES,
                    ],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { ProServiceApiModule, ProfessionalServicePriceType, ProfessionalServiceService, ProfessionalServiceSubResource, ProfessionalServiceTypeService };
